import {
  Controller,
  FieldValues,
  useFormContext,
} from "@lya-protect/lya-protect-form-library/dist/Exports/reactHookForm.exports";
import { InputProps } from "@lya-protect/lya-protect-form-library/dist/FormAPI/Inputs/inputs";
import { UIInputContainer } from "@lya-protect/lya-protect-form-library/dist/UI";
import { Wysiwyg, WysiwygResize } from "./Wysiwyg";

export type InputWysiwygProps<TFieldValues extends FieldValues> = Pick<
  InputProps<TFieldValues, string>,
  "label" | "name" | "required" | "onChange"
> & {
  variant?: "medium" | "large";
  placeholder?: string;
  resize?: WysiwygResize;
  disabled?: boolean;
};

export function InputWysiwyg<TFieldValues extends FieldValues>({
  name,
  label,
  required,
  onChange,
  placeholder,
  variant = "medium",
  resize,
  disabled,
}: InputWysiwygProps<TFieldValues>) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={
        required
          ? {
              validate: (value: string) =>
                (value && value.replace(/<[^>]*>/g, "").trim() !== "") ||
                "Ce champ est obligatoire",
            }
          : undefined
      }
      render={({ field, fieldState: { error, isTouched } }) => (
        <UIInputContainer
          name={field.name}
          size={variant}
          label={label}
          required={required}
          errorMessage={error?.message}
        >
          <Wysiwyg
            value={field.value}
            placeholder={placeholder}
            resize={resize}
            readOnly={disabled}
            onChange={(value) => {
              field.onChange(value);
              onChange?.(value, isTouched);
            }}
          />
        </UIInputContainer>
      )}
    />
  );
}
